// src/pages/IslemeAlinanApplicationsPage.js
import React from 'react';
import ApplicationsPage from './ApplicationsPage';

const UnresolvedApplicationsPage = () => {
  return <ApplicationsPage statusName="çözülemedi" pageTitle="Çözülemeyen Başvurular" />;
};

export default UnresolvedApplicationsPage;